// ChartToggle.jsx (Tabs version)
import React from 'react';
import { Tab } from '@headlessui/react';

const METRICS = [
  { key: 'raw', label: 'Total Employment' },
  { key: 'pctOfTotal', label: '% of Total Nonfarm' },
  { key: 'yoyGrowth', label: 'YOY Growth %' },
  { key: 'since2000', label: '% Change Since 2000' },

];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function ChartToggle({ metricMode, setMetricMode }) {
  // We'll map the selected tab to metricMode
  const currentIndex = METRICS.findIndex((m) => m.key === metricMode);

  return (
    <Tab.Group selectedIndex={Math.max(0, currentIndex)} onChange={(idx) => setMetricMode(METRICS[idx].key)}>
      <Tab.List className="flex space-x-2 bg-gray-100 p-1 rounded-md">
        {METRICS.map((m) => (
          <Tab
            key={m.key}
            className={({ selected }) =>
              classNames(
                'px-3 py-1 rounded-md focus:outline-none',
                selected
                  ? 'bg-white text-blue-600 font-medium shadow'
                  : 'text-gray-600 hover:bg-white hover:shadow'
              )
            }
          >
            {m.label}
          </Tab>
        ))}
      </Tab.List>
    </Tab.Group>
  );
}